export default __webpack_public_path__ + "static/media/facebook.ae82181a.png";